import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';

@Directive({ selector: '[autoSize]' })

export class AutoSizeDirective {
    private el = inject(ElementRef);


    private _autoSize: number;

    @Input() set autoSize(autoSize: number){
        this._autoSize = autoSize;
        setTimeout( ()=>{
            this.onResize();
        },100 );
    }

    @HostListener('window:resize')
    onResize() {
        const height =  window.innerHeight;
        let containerHeight =  height - 110 ;
        if(this._autoSize !== undefined){
            containerHeight = containerHeight - this._autoSize;
        }
        this.el.nativeElement.style.maxHeight = containerHeight + 'px';
        this.el.nativeElement.style.overflowY = 'auto';
        this.el.nativeElement.style.display = 'block';
    }
}

@Directive({ selector: '[autoSizeMin]' })
export class AutoSizeMinDirective {
    private el = inject(ElementRef);

    private _autoSizeMin: number;

    @Input() set autoSizeMin(autoSizeMin: number){
        this._autoSizeMin = autoSizeMin;
        setTimeout( ()=>{
            this.onResize();
        },100 );
    }

    @HostListener('window:resize')
    onResize() {
        let containerHeight =  window.innerHeight;
        if(this._autoSizeMin !== undefined){
            containerHeight = containerHeight - this._autoSizeMin;
        }
        this.el.nativeElement.style.minHeight = containerHeight + 'px';
        this.el.nativeElement.style.overflowY = 'auto';
        this.el.nativeElement.style.display = 'block';
    }
}
